import { notification } from "antd";
import i18n from "../../../i18n";
export const openNotification = (type: "success" | "info" | "warning" | "error", message?: string): void => {
  notification[type]({
    message: type[0].toUpperCase() + type.slice(1),
    description: message
  });
};
export const ServerError = (): void => {
  notification["error"]({
    message: i18n.t("serverError"),
    description: i18n.t("serverErrorMsg")
  });
};
